import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state,
    state => state.updateUserIntegration
)

export const selectIsCreateUserIntegrationModalOpen = createSelector(
    baseSelector,
    (state) => state.isCreateUserIntegrationModalOpen
)

export const selectIsUpdateUserIntegrationModalOpen = createSelector(
    baseSelector,
    (state) => state.isUpdateUserIntegrationModalOpen
)

export const selectIsDeleteUserIntegrationModalOpen = createSelector(
    baseSelector,
    (state) => state.isDeleteUserIntegrationModalOpen
)

export const selectOnCreate = createSelector(
    baseSelector,
    (state) => state.onCreate
)

export const selectOnDelete = createSelector(
    baseSelector,
    (state) => state.onDelete
)

export const selectOnUpdate = createSelector(
    baseSelector,
    (state) => state.onUpdate
)

export const selectCurrentIntegration = createSelector(
    baseSelector,
    (state) => state.currentIntegration
)
